var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraphBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 79,
    viewBox: "0 0 263 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.0277 33.7276C30.239 35.4934 0 55.1472 0 55.1472V69.0005C0 74.5233 4.47715 79.0005 10 79.0005H253C258.523 79.0005 263 74.5234 263 69.0005V28.3727C263 28.3727 242.614 34.4371 229.012 33.7276C201.374 32.2861 204.61 4.44251 177.222 1.59824C140.845 -2.17943 141.082 39.1723 104.391 41.2245C84.6824 42.3268 74.6928 32.3268 55.0277 33.7276Z",
    fill: "url(#paint0_linear_2294_2791)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 55.1472C0 55.1472 30.239 35.4934 55.0277 33.7276C74.6928 32.3268 84.6824 42.3268 104.391 41.2245C141.082 39.1723 140.845 -2.17943 177.222 1.59824C204.61 4.44251 201.374 32.2861 229.012 33.7276C242.614 34.4371 263 28.3727 263 28.3727",
    stroke: "#60DBFF",
    strokeWidth: 1.91724,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2294_2791",
    x1: 131.5,
    y1: 1.35449,
    x2: 131.5,
    y2: 104.762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60DBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphBlue);
export default __webpack_public_path__ + "static/media/graph-blue.70ec127203dee0e7ee40d14b80c1f1da.svg";
export { ForwardRef as ReactComponent };